
import clone from 'lodash/clone'
import { WordcutCore } from './wordcut_core'
import { PathInfoBuilder } from './path_info_builder'
import { PathSelector } from './path_selector'
import { Acceptors, acceptors } from './acceptors'
import { LatinRules } from './latin_rules'
import { ThaiRules } from './thai_rules'
import { WordcutDict } from './dict'

let initNoDict = () => {
    Wordcut.pathInfoBuilder = Wordcut.defaultPathInfoBuilder
    Wordcut.pathSelector = Wordcut.defaultPathSelector;
    Wordcut.acceptors = Wordcut.defaultAcceptors;
    Wordcut.defaultLatinRules.forEach(function (rule: any) {
        acceptors.creators.push(rule);
    })
    Wordcut.defaultThaiRules.forEach(function (rule: any) {
        acceptors.creators.push(rule);
    })
}

let init = (dict_path?: any, withDefault?: any, additionalWords?: any) => {
    withDefault = withDefault || false
    initNoDict()
    let dict = clone(Wordcut.defaultDict);
    dict.init(dict_path, withDefault, additionalWords);
    acceptors.creators.push(dict)
}

export let Wordcut = Object.create(WordcutCore)
Wordcut.defaultPathInfoBuilder = PathInfoBuilder
Wordcut.defaultPathSelector = PathSelector
Wordcut.defaultAcceptors = Acceptors
Wordcut.defaultLatinRules = LatinRules
Wordcut.defaultThaiRules = ThaiRules
Wordcut.defaultDict = WordcutDict
Wordcut.initNoDict = initNoDict
Wordcut.init = init
